
import React from 'react'
import Link from 'components/Link'
import { prepareData } from 'utils/googleData'

  export function HandyLinks(props) {
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, items,gatsbyImageSrc } = prepareData({
        props,
    })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    return (
  <section className="space-y-8">
    <div className="text-center">
      <h2 className="mb-1 mt-4 font-bold">{title}</h2>
    </div>
    <div className="grid grid-cols-1 border-t border-l border-dashed border-gray-accent-light dark:border-gray-accent-dark md:grid-cols-2 lg:grid-cols-3">
      {items.map(category => (
        <div
          key={category.title}
          className="space-y-2 border-b border-r border-dashed border-gray-accent-light py-4 px-4 dark:border-gray-accent-dark md:py-6 md:px-8"
        >
          <h4 className="mb-0">{category.title}</h4>
          <ul className="space-y-1 p-0">
            {category.links.map(link => (
              <li key={link.url} className="list-none">
                <Link to={link.url}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
)
};
export default HandyLinks
